import { ComfortProvider } from "./app/ComfortContext";
import { AppRouter } from "./app/router";

export function App() {
  return (
    <ComfortProvider>
      <AppRouter />
    </ComfortProvider>
  );
}
